import { render, staticRenderFns } from "./OrderFormListOld.vue?vue&type=template&id=026d025c&scoped=true"
import script from "./OrderFormListOld.vue?vue&type=script&lang=js"
export * from "./OrderFormListOld.vue?vue&type=script&lang=js"
import style0 from "./OrderFormListOld.vue?vue&type=style&index=0&id=026d025c&prod&lang=css"
import style1 from "./OrderFormListOld.vue?vue&type=style&index=1&id=026d025c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026d025c",
  null
  
)

export default component.exports